import { motion } from "framer-motion";

export const BouncyButton = ({ children, onClick, variant = "blue", className = "", testId, type = "button" }) => {
    const styles = {
        blue: "bg-monster-blue text-white shadow-sticker hover:bg-[#1a63c2]",
        green: "bg-monster-green text-monster-navy shadow-sticker hover:bg-[#2db350]",
        yellow: "bg-monster-yellow text-monster-navy shadow-sticker hover:bg-[#f0c000]",
        white: "bg-white text-monster-navy shadow-sticker hover:bg-monster-cream",
    };
    return (
        <motion.button
            type={type}
            data-testid={testId}
            onClick={onClick}
            whileHover={{ y: -2 }}
            whileTap={{ y: 4, scale: 0.97 }}
            transition={{ type: "spring", stiffness: 400, damping: 15 }}
            className={`inline-flex items-center justify-center gap-2 rounded-full border-2 border-monster-navy px-7 py-3.5 font-display font-semibold text-base tracking-wide ${styles[variant]} ${className}`}
        >
            {children}
        </motion.button>
    );
};
